'use client'

import type { ReactNode } from 'react'
import type { GeneralSetting } from '@/payload-types'

import { GeneralSettingsContext } from '@/utilities/GeneralSettingsContext'

export default function GeneralSettingsProvider({
  generalSettings,
  children,
}: {
  generalSettings: GeneralSetting | null
  children: ReactNode
}) {
  return (
    <GeneralSettingsContext.Provider value={generalSettings}>
      {children}
    </GeneralSettingsContext.Provider>
  )
}
